import VendorInfoModal from './VendorInfoModal';

export default VendorInfoModal;
